import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchSavedPosts } from "./UAFetchSavedPosts";
import "../../Styles/UASavedContent.css";
import "../../../Styles/common-styles.css";
import Carousel from "../../../../common/Carousel/Carousel";
import GridLayout from "../../../../common/Grid/gridMode";
import LightboxGallery from "../../../../common/LightBox/lightBox";
import HorizontalScrollDisplay from "../../../../common/HorizontalScroll/horizontalScroll";
import VerticalScroll from "../../../../common/VerticalScroll/verticalScroll";

const UASavedContent = ({ mediaDisplayMode }) => {
  const [savedPosts, setSavedPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSavedPosts().then((data) => {
      setSavedPosts(data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="uasc-loading">
        <p className="text-header">Loading saved posts...</p>
      </div>
    );
  }

  return (
    <div className="uasc-saved-feed-container">
      {savedPosts.posts && savedPosts.posts.length > 0 ? (
        savedPosts.posts.map((post) => (
          <div key={post.postId} className="uasc-post-wrapper">
            {/* Header Section - Outside Card with Black Background */}
            <div className="uasc-post-header-section">
              {/* Post ID */}
              <div className="uasc-post-id">
                <Link
                  to={`/post-page/${post.postId}`}
                  className="uasc-post-id-link"
                >
                  {post.postId}
                </Link>
              </div>

              {/* User Info */}
              <div className="uasc-user-info-wrapper">
                <div className="uasc-user-avatar-wrapper">
                  <img
                    src={post.userimage}
                    alt="User"
                    className="tt-profile-image"
                  />
                </div>

                <div className="uasc-user-details">
                  <div className="uasc-user-name-row">
                    <Link
                      to={`/user-account/${post.userId}`}
                      className="uasc-user-name-link"
                      style={{color: "white"}}
                    >
                      <span className="text-header">{post.userName}</span>
                    </Link>

                    {/* Highlighted Profile Badge */}
                    {post.profileId && (
                      <div className="uasc-profile-badge" style={{background: "rgba(36,36,45,0.2)", color: "white", border: "1px solid white"}}>
                        <Link
                          to={`/user-page/${post.userId}/${post.profileId}`}
                          className="uasc-profile-link"
                          style={{color: "white"}}
                        >
                          #{post.profileId}
                        </Link>
                      </div>
                    )}
                  </div>

                  {/* Timestamp on Next Line */}
                  <div className="uasc-timestamp-row">
                    <span className="text-label uasc-timestamp">
                      {new Date(post.timestamp).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Post Card - Content Only */}
            <div className="uasc-saved-feed-card">
              {/* Description */}
              <div className="uasc-post-description">
                <p className="text-label">{post.descriptions}</p>
              </div>

              {/* Media Content */}
              <div className="uasc-saved-feed-media">
                {Array.isArray(post.medias) && post.medias.length > 0 && (
                  <div className="uasc-feed-media-container">
                    {mediaDisplayMode === "slideshow" ? (
                      <Carousel items={post.medias} />
                    ) : mediaDisplayMode === "lightbox" ? (
                      <LightboxGallery mediaFiles={post.medias} />
                    ) : mediaDisplayMode === "horizontal-scroll" ? (
                      <HorizontalScrollDisplay medias={post.medias} />
                    ) : mediaDisplayMode === "vertical-scroll" ? (
                      <VerticalScroll medias={post.medias} />
                    ) : (
                      <GridLayout mediaFiles={post.medias} />
                    )}
                  </div>
                )}
              </div>

              {/* Location Footer */}
              <div className="uasc-post-location">
                <Link
                  to={`/location-page/${post.location}`}
                  className="uasc-location-link"
                  style={{color: "white"}}
                >
                  {post.location}
                </Link>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="uasc-no-posts">
          <p className="text-label">No saved posts found.</p>
        </div>
      )}
    </div>
  );
};

export default UASavedContent;
